import React from 'react';

import { Helmet } from 'react-helmet';  // ✅ Import Helmet
import { useNavigate } from "react-router-dom";




const WorkWithUs = () => {
    const navigate = useNavigate()
  return (
    <section className="workwithus-section"
    style={{
         backgroundImage: `url(${process.env.PUBLIC_URL}/letworkimg.svg)`,
      }}
      >
        {/* ✅ SEO Meta Tags */}
      {/* <Helmet>
        <title>Work With Us | Pravisht Digital</title>
        <meta
          name="description"
          content="Partner with Pravisht Digital for custom-built, scalable software solutions with global quality and smart performance."
        />
        <meta name="keywords" content="Work with Us, Custom Software, Scalable Solutions, Pravisht Digital" />
        <meta property="og:title" content="Work With Us | Pravisht Digital" />
        <meta
          property="og:description"
          content="Get custom-built software solutions that are smart, scalable, and built to perform with Pravisht Digital."
        />
        <meta property="og:type" content="website" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet> */}
      <div className="workwithus-content"
      >
        <h2>Let’s work with Us</h2>
        <p>
          Get custom-built software with global quality.
          Smart, scalable, and built to perform.</p>
        <button className="know-more-btn" onClick={()=> navigate('/Contact-us')}>Talk to Us</button>
      </div>
    </section>
  );
};

export default WorkWithUs;
